export default __webpack_public_path__ + "static/media/shield.ad876c7b.svg";